"use client";

import { Grid2 } from "@repo/ui";
import { type SVGProps } from "react";
import Section from "../components/Section";
import CategoryCard from "../components/CategoryCard";

type WHY_CHOOSE_SPOCLEARN = {
  data: {
    title: string;

    description: string;
    icon?: ({
      title,
      titleId,
      desc,
      descId,
      ...props
    }: SVGProps<SVGSVGElement> & {
      title: string;
      titleId: string;
      desc: string;
      descId: string;
    }) => React.JSX.Element;
  }[];
};
const EngageWithUs = ({ data }: WHY_CHOOSE_SPOCLEARN) => {
  return (
    <Section title="Engage With Us">
      <Grid2 container spacing={4}>
        <Grid2 size={{ sm: 6, md: 4, lg: 4 }}>
          <CategoryCard
            isContentType
            className="!text-black bg-[linear-gradient(127deg,_#FFF_0%,_#E0F1FC_71.61%)]"
            {...data[0]}
          />
        </Grid2>
        <Grid2 size={{ sm: 6, md: 4, lg: 4 }}>
          <CategoryCard
            isContentType
            className="!text-black bg-[linear-gradient(127deg,_#FFF_0%,_#E0F1FC_71.61%)]"
            {...data[1]}
          />
        </Grid2>
        <Grid2 size={{ sm: 6, md: 4, lg: 4 }}>
          <CategoryCard
            isContentType
            className="!text-black bg-[linear-gradient(127deg,_#FFF_0%,_#E0F1FC_71.61%)]"
            {...data[2]}
          />
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default EngageWithUs;
